// extracted by mini-css-extract-plugin
export default {"secondaryFont":"SecondaryFont-module--secondaryFont--2rMQa"};